import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, {useEffect, useState} from 'react';
import {cloneDeep} from 'lodash';
import {
    CANDIDATE_CATEGORY_FIELDS,
    LOCAL_STORAGE_NEXT_FOLLOW_UP_PLAN,
    LOCAL_STORAGE_USER_LOGIN_INFO,
    ORDER_BY, ResponseCode
} from "@app/constants/Common";
import ReactChipInput from "react-chip-input";
import {arrayIncludeItem, stringToOption} from "@app/utils/CommonUtils";
import {requestCandidates} from "@app/services/CandidateService";
import CandidateListTable, {CandidateListMode} from "@pages/candidate/list/CandidateListTable";
import {requestStartRunJob} from "@app/services/JobService";
import {
    requestGetEmailInviteTempDataDVTJCUV,
    requestSaveEmailInviteTempDataDVTJCUV,
    requestStartRunDVTJCUV
} from "@pages/dvtjcuv/service/DVTJCUVService";
import {toast} from "react-toastify";
import fe from "react-datepicker";
import DVTJCUVNextFollowUpPlan from "@pages/candidate/list/DVTJCUVNextFollowUpPlan";
import {alertMessage, showMessage} from "@app/constants/Messages";
import SelectDVTJCUVMailTemplateContent from "@pages/dvtjcuv/rundvtjcuv/SelectDVTJCUVMailTemplateContent";
import {EmailInviteMode} from "@pages/candidate/list/DVTJCUVEmailInviteModal";
import {MailTempType} from "@pages/email/common/Constant";
import {DVTJCUVAcquireCddParentTabIds} from "@pages/dvtjcuv/common/AcquireCddTabs";

const DVTJCUVEmailInviteTempInfoModal = (props) => {
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [cddId, setCddId] = useState('');
    const [selectMailTemplateId, setSelectMailTemplateId] = useState(0);
    const [inviteMode, setInviteMode] = useState(EmailInviteMode.INVITE_EMAIL);

    const [nextFollowUpPlan, setNextFollowUpPlan] = useState({
        current_fu_campaign: "",
        current_fu_strategy_date_time: "",
        next_fu_campaign: "",
        next_fu_strategy_date_time: "",
        todo_w_cdd_dvtjcuv: []
    });

    const {candidateId, isShow, parentTab, subTab, onClose} = props

    const fetchTempData = async (canId) => {
        const res = await requestGetEmailInviteTempDataDVTJCUV(canId)
        if (res.sts_code === ResponseCode.SUCCESS) {
            const runDV = res.content
            setSelectMailTemplateId(runDV.invite_mail_template)
            setNextFollowUpPlan({
                current_fu_campaign: runDV.current_fu_campaign,
                current_fu_strategy_date_time: runDV.current_fu_strategy_date_time,
                next_fu_campaign: runDV.next_fu_campaign,
                next_fu_strategy_date_time: runDV.next_fu_strategy_date_time,
                todo_w_cdd_dvtjcuv: stringToOption(runDV.to_do_w_cdd),
                invite_send_job_todo_w_rec: stringToOption(runDV.invite_send_job_todo_w_rec),
            })
        }
    }

    useEffect(() => {
        if (candidateId) {
            setCddId(candidateId)
            fetchTempData(candidateId)
        }
    }, [candidateId])

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    },[])

    useEffect(() => {
        if (parentTab.id === DVTJCUVAcquireCddParentTabIds.FU_EMAIL_TAB) {
            setInviteMode(EmailInviteMode.INVITE_EMAIL_FU)
        } else {
            setInviteMode(EmailInviteMode.INVITE_EMAIL)
        }
    },[parentTab, subTab])

    const onChangeNextFollowUpPlan = (data) => {
        setNextFollowUpPlan(data)
        // localStorage.setItem(LOCAL_STORAGE_NEXT_FOLLOW_UP_PLAN, JSON.stringify(nextFollowUpPlan));
    }

    const onChangeMailTemp = (temp) => {
        setSelectMailTemplateId(temp ? temp.value : '')
    }

    const onSave = async () => {
        requestSaveEmailInviteTempDataDVTJCUV({
            candidate_id: candidateId,
            next_follow_up_plan: nextFollowUpPlan,
            mail_template_id: selectMailTemplateId,
        }).then(res => {
            alertMessage(res.sts_code, false, true)
            if (res.sts_code === ResponseCode.SUCCESS) {
                onClose()
            }
        })
    }

    const onCloseModal = () => {
        setSelectMailTemplateId(0)
        onClose()
    }

    return (
        <>
            <Modal show={isShow}
                   size={'xl'}
                   onHide={onCloseModal}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>TT lưu tạm email mời DVTJCUV</Modal.Title>
                    <Button variant='secondary' onClick={onCloseModal}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body style={{overflowY: 'auto', maxHeight: '70vh'}}>
                    <SelectDVTJCUVMailTemplateContent
                        tempType={inviteMode === EmailInviteMode.INVITE_EMAIL_FU ?
                            MailTempType.DVTJCUV_EMAIL_FU : MailTempType.DVTJCUV_INVITE_EMAIL}
                        selectedId={selectMailTemplateId || 0}
                        onSelect={temp => onChangeMailTemp(temp)}/>
                    <DVTJCUVNextFollowUpPlan
                        mode={inviteMode}
                        onChange={(data) => onChangeNextFollowUpPlan(data)}
                        nextFollowUpPlan={nextFollowUpPlan}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <button type='button'
                            className='btn btn-primary'
                            onClick={() => onSave()}>
                        Save
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default DVTJCUVEmailInviteTempInfoModal;
